'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { VerticalInsertDropTarget, HorizontalInsertDropTarget, SHADE_ABOVE, SHADE_BELOW, SHADE_LEFT, SHADE_RIGHT, SHADE_BOTH as DROP_TARGET_SHADE_BOTH } from 'layout-dnd-components/InsertDropTargets';
import StyledPlaceholder from 'LayoutBuilderUI/components/dragAndDrop/StyledPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
const SHADE_THICKNESS = 8;
export const SHADE_NONE = 'SHADE_NONE';
export const SHADE_AUTO = 'SHADE_AUTO';
export const SHADE_BOTH = 'SHADE_BOTH';
export class SnapPlaceholder extends Component {
  getShadeProps() {
    const {
      position,
      shade,
      isVertical
    } = this.props;
    if (!shade || shade === SHADE_NONE) {
      return undefined;
    }
    if (shade === SHADE_BOTH) {
      return DROP_TARGET_SHADE_BOTH;
    }
    const isAfter = position === 'after';
    if (isVertical) {
      return isAfter ? SHADE_LEFT : SHADE_RIGHT;
    } else {
      return isAfter ? SHADE_ABOVE : SHADE_BELOW;
    }
  }
  render() {
    const {
      isVisible,
      position,
      isVertical
    } = this.props;
    const display = isVisible ? 'block' : 'none';
    let inner;
    if (isVertical) {
      inner = /*#__PURE__*/_jsx(VerticalInsertDropTarget, {
        height: "100%",
        top: 0,
        left: 0,
        shade: this.getShadeProps(),
        shadeThickness: SHADE_THICKNESS
      });
    } else {
      inner = /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
        width: "100%",
        top: 0,
        left: 0,
        shade: this.getShadeProps(),
        shadeThickness: SHADE_THICKNESS
      });
    }
    return /*#__PURE__*/_jsx(StyledPlaceholder, {
      ref: this.props.getRef,
      display: display,
      isVertical: isVertical,
      positionInFlow: position,
      "data-test-id": "snap-placeholder",
      children: inner
    });
  }
}
SnapPlaceholder.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  position: PropTypes.string,
  isVertical: PropTypes.bool,
  shade: PropTypes.oneOf([SHADE_NONE, SHADE_AUTO, SHADE_BOTH]).isRequired,
  getRef: PropTypes.func
};
SnapPlaceholder.defaultProps = {
  shade: SHADE_NONE
};